<template>
  <div class="column is-half">
    <nav class="panel">
      <p class="panel-heading">{{ mode === 'from' ? 'Van' : 'naar' }} {{ dossiers[mode].nr }} {{ dossiers[mode].name }}</p>

      <div class="panel-block">
        <p class="control has-icons-left">
          <input class="input" v-model="filter" placeholder="Zoeken">
          <span class="icon is-left">
            <i class="fas fa-search" aria-hidden="true"></i>
          </span>
        </p>
      </div>
      <a
        class="panel-block"
        :class="{ 'is-active': selected === item.nr }"
        v-for="(item, idx) in filteredItems"
        :key="idx"
        @click="$emit('select', { mode: mode, item: item })">

        {{ getTitle(item) }}
      </a>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    mode: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      filter: null
    }
  },
  computed: {
    ...mapGetters({
      dossiers: 'dossiers/dossiers'
    }),
    filteredItems () {
      if (!this.filter) return this.items.filter(item => item !== null)

      return this.items.filter(item => {
        return item !== null && (item.hoofdstuk + ' ' + item.titel).toLowerCase().includes(this.filter.toLowerCase())
      })
    }
  },
  methods: {
    getTitle (item) {
      return `${item.hoofdstuk} ${item.titel}`
    }
  }
}
</script>

<style lang="css" scoped>
.panel-block.is-active {
  background-color: hsl(171, 100%, 41%);
}
</style>
